var _rect, _rect2, _rect3, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _circle4, _circle5, _circle6, _path34, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _path35, _rect28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowAudience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 429,
    viewBox: "0 0 506 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 496,
    height: 418.925,
    rx: 20,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 496,
    height: 418.925,
    rx: 20,
    stroke: "black",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 496,
    height: 418.925,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 9.95431 9.9543 1 21 1H477C488.046 1 497 9.95431 497 21V40.0295H1V21Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.85768
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5226,
    cy: 20.1439,
    r: 4.50796,
    fill: "#FFC900"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3966,
    cy: 20.144,
    r: 4.50796,
    fill: "#E2442F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.0451,
    cy: 20.1439,
    r: 4.50796,
    fill: "#23A094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0194 99.9992H49.7839V77.6068H47.3371C46.5745 80.7417 44.1913 82.5331 41.0137 82.853L41.5539 85.7001C43.7147 85.5401 46.0979 84.0686 47.0194 81.9893V99.9992Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4465 100.319C66.6896 100.319 69.3588 97.1202 69.3588 93.6014C69.3588 90.8823 67.8336 88.4831 65.0055 87.5554C67.0074 86.6277 68.1195 85.1242 68.1195 82.981C68.1195 79.846 65.5457 77.2869 61.4465 77.2869C57.3474 77.2869 54.7735 79.846 54.7735 82.981C54.7735 85.1242 55.8857 86.6277 57.8876 87.5554C55.0595 88.4831 53.5343 90.8823 53.5343 93.6014C53.5343 97.1202 56.1717 100.319 61.4465 100.319ZM61.4465 86.5318C59.0633 86.5318 57.4427 85.1882 57.4427 83.1089C57.4427 81.1256 59.0633 79.7821 61.4465 79.7821C63.8297 79.7821 65.4503 81.1256 65.4503 83.1089C65.4503 85.1882 63.8297 86.5318 61.4465 86.5318ZM61.4465 97.728C58.1736 97.728 56.267 95.8726 56.267 93.2815C56.267 90.6904 58.3325 88.867 61.4465 88.867C64.5606 88.867 66.6261 90.6904 66.6261 93.2815C66.6261 95.8726 64.7195 97.728 61.4465 97.728Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3001 103.582C74.8253 103.582 76.0964 102.974 76.0964 100.831V96.6404H72.7916V99.9992H73.3636C74.0627 99.9992 74.5076 100.351 74.5076 100.991C74.5076 101.727 73.9991 102.047 73.2683 102.047C72.6645 102.047 72.2832 101.887 72.029 101.759L71.743 103.294C72.1243 103.454 72.601 103.582 73.3001 103.582Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.823 77.6068H80.8732C80.8732 81.4455 80.5872 85.2202 79.9199 89.6347L82.8434 90.3065C83.5742 88.707 85.6079 87.3315 87.864 87.3315C91.3912 87.3315 93.0753 89.6027 93.0753 92.4818C93.0753 95.3608 91.2641 97.728 87.6733 97.728C84.5593 97.728 82.7798 95.9046 82.3349 92.9616L79.6657 93.7293C80.2377 98.1119 83.6378 100.319 87.6733 100.319C92.7575 100.319 95.8398 96.8963 95.8398 92.1619C95.8398 87.4914 92.5351 84.8363 88.4995 84.8363C85.9256 84.8363 83.8602 85.988 82.6527 87.3955C83.1293 84.9643 83.4471 82.2452 83.4471 80.1979H94.823V77.6068Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.287 99.9992H111.051V94.2732H114.833V91.778H111.051V84.5165H108.287V91.778H101.201C104.887 88.0992 105.808 84.1326 105.808 79.0463V77.6068H103.044V79.0463C103.044 84.4845 102.249 87.5234 98.2772 91.3621V94.2732H108.287V99.9992Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.499 100.319C130.854 100.319 133.047 94.5611 133.047 88.739C133.047 82.5331 130.759 77.2869 124.499 77.2869C120.336 77.2869 117.095 80.3259 117.095 84.8363C117.095 88.739 119.859 92.0019 124.435 92.0019C127.327 92.0019 129.519 90.2425 130.473 87.7474C130.473 88.1312 130.504 88.4831 130.504 88.899C130.473 94.785 128.058 97.728 124.658 97.728C121.639 97.728 119.764 96.0645 119.446 92.8976L116.745 93.6973C117.158 97.2481 119.923 100.319 124.499 100.319ZM124.658 89.5068C121.957 89.5068 119.859 87.7474 119.859 84.7404C119.859 81.8294 121.83 79.7821 124.658 79.7821C127.517 79.7821 129.488 81.8294 129.488 84.6444C129.488 87.5874 127.39 89.5068 124.658 89.5068Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M204.904 99.9755H207.81V94.2554H211.785V91.7629H207.81V84.5089H204.904V91.7629H197.455C201.33 88.0879 202.298 84.1254 202.298 79.0444V77.6064H199.392V79.0444C199.392 84.4769 198.557 87.5127 194.382 91.3474V94.2554H204.904V99.9755Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M222.275 100.295C227.787 100.295 230.593 97.0995 230.593 93.5844C230.593 90.8681 228.989 88.4714 226.017 87.5447C228.121 86.618 229.29 85.116 229.29 82.975C229.29 79.8433 226.584 77.2869 222.275 77.2869C217.967 77.2869 215.261 79.8433 215.261 82.975C215.261 85.116 216.43 86.618 218.534 87.5447C215.562 88.4714 213.958 90.8681 213.958 93.5844C213.958 97.0995 216.731 100.295 222.275 100.295ZM222.275 86.5221C219.77 86.5221 218.067 85.18 218.067 83.1028C218.067 81.1216 219.77 79.7794 222.275 79.7794C224.781 79.7794 226.484 81.1216 226.484 83.1028C226.484 85.18 224.781 86.5221 222.275 86.5221ZM222.275 97.7067C218.835 97.7067 216.831 95.8532 216.831 93.2648C216.831 90.6764 219.002 88.8549 222.275 88.8549C225.549 88.8549 227.72 90.6764 227.72 93.2648C227.72 95.8532 225.716 97.7067 222.275 97.7067Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M238.588 99.9755H241.494V77.6064H238.922C238.12 80.7381 235.615 82.5276 232.275 82.8472L232.843 85.6913C235.114 85.5315 237.619 84.0615 238.588 81.9844V99.9755Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M342.269 93.5371C342.269 90.2538 340.175 88.1734 335.289 87.1981V79.7864C337.161 80.274 338.367 81.6068 338.969 83.6873L341.539 82.257C340.492 79.2662 338.208 77.4458 335.289 76.9907V74H332.656V76.9257C328.785 77.3483 326.311 79.9164 326.311 82.9071C326.311 86.548 328.754 88.5309 332.656 89.4737V97.4055C329.769 96.9179 327.992 94.8699 327.136 91.7817L324.534 93.2446C325.867 97.7306 329.261 99.7461 332.656 100.169V103.127H335.289V100.201C339.477 99.7786 342.269 97.178 342.269 93.5371ZM329.134 82.8746C329.134 81.1192 330.499 79.8839 332.656 79.6563V86.613C330.467 85.9303 329.134 84.8901 329.134 82.8746ZM335.289 97.4706V90.0263C338.462 90.774 339.445 91.9768 339.445 93.7972C339.445 95.7151 337.954 97.1455 335.289 97.4706Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M345.126 99.9411H360.29V97.308H348.552C348.933 94.7724 351.851 93.3746 354.834 91.7817C358.133 90.0588 360.259 87.9458 360.259 84.0124C360.259 79.8839 357.467 76.8607 352.518 76.8607C347.695 76.8607 344.65 80.209 344.65 84.1749C344.65 85.8328 345.157 87.5232 346.331 89.0836L348.679 87.5232C347.886 86.5155 347.442 85.3127 347.442 83.9799C347.442 81.5418 349.44 79.3963 352.391 79.3963C355.563 79.3963 357.499 81.3792 357.499 84.1424C357.499 87.4582 355.119 88.8235 351.28 90.8065C347.949 92.4969 345.126 94.935 345.126 99.9411Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M371.999 100.266C377.456 100.266 380.914 95.7151 380.914 88.5634C380.914 81.4118 377.456 76.8607 371.999 76.8607C366.574 76.8607 363.116 81.4118 363.116 88.5634C363.116 95.7151 366.574 100.266 371.999 100.266ZM371.999 97.7306C367.97 97.7306 365.844 93.7322 365.844 88.5634C365.844 83.3947 367.97 79.3963 371.999 79.3963C376.06 79.3963 378.154 83.3947 378.154 88.5634C378.154 93.7322 376.06 97.7306 371.999 97.7306Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M388.864 99.9411H391.624V77.1858H389.181C388.42 80.3715 386.041 82.1919 382.868 82.517L383.407 85.4102C385.565 85.2477 387.944 83.7523 388.864 81.6393V99.9411Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M396.638 103.582C398.161 103.582 399.43 102.964 399.43 100.786V96.5278H396.13V99.9411H396.701C397.399 99.9411 397.843 100.299 397.843 100.949C397.843 101.697 397.336 102.022 396.606 102.022C396.003 102.022 395.622 101.859 395.369 101.729L395.083 103.289C395.464 103.452 395.94 103.582 396.638 103.582Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M411.718 100.266C417.175 100.266 420.633 95.7151 420.633 88.5634C420.633 81.4118 417.175 76.8607 411.718 76.8607C406.293 76.8607 402.835 81.4118 402.835 88.5634C402.835 95.7151 406.293 100.266 411.718 100.266ZM411.718 97.7306C407.689 97.7306 405.563 93.7322 405.563 88.5634C405.563 83.3947 407.689 79.3963 411.718 79.3963C415.779 79.3963 417.873 83.3947 417.873 88.5634C417.873 93.7322 415.779 97.7306 411.718 97.7306Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M431.121 100.266C436.356 100.266 439.021 97.0154 439.021 93.4396C439.021 90.6764 437.498 88.2384 434.674 87.2956C436.673 86.3529 437.784 84.8251 437.784 82.647C437.784 79.4613 435.214 76.8607 431.121 76.8607C427.029 76.8607 424.459 79.4613 424.459 82.647C424.459 84.8251 425.569 86.3529 427.568 87.2956C424.744 88.2384 423.221 90.6764 423.221 93.4396C423.221 97.0154 425.855 100.266 431.121 100.266ZM431.121 86.2554C428.742 86.2554 427.124 84.8901 427.124 82.7771C427.124 80.7616 428.742 79.3963 431.121 79.3963C433.501 79.3963 435.119 80.7616 435.119 82.7771C435.119 84.8901 433.501 86.2554 431.121 86.2554ZM431.121 97.6331C427.853 97.6331 425.95 95.7476 425.95 93.1145C425.95 90.4814 428.012 88.6285 431.121 88.6285C434.23 88.6285 436.292 90.4814 436.292 93.1145C436.292 95.7476 434.389 97.6331 431.121 97.6331Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M449.237 100.266C453.679 100.266 457.105 97.178 457.105 92.3994C457.105 87.8808 453.838 85.3777 450.475 85.3777C450.062 85.3777 449.618 85.4102 449.301 85.4752L456.249 79.3313V77.1858H442.004V79.8189H452.061L444.574 86.5805L446.16 88.596C446.858 87.9458 448.064 87.4582 449.333 87.4582C452.283 87.4582 454.377 89.3436 454.377 92.5944C454.377 95.7476 452.029 97.6331 449.237 97.6331C446.065 97.6331 444.066 95.5201 443.685 92.4969L441.052 93.6997C441.814 97.438 444.732 100.266 449.237 100.266Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M350.231 122.762H343V123.794H346.07V131.061H347.161V123.794H350.231V122.762Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M352.388 131.179C354.095 131.179 355.245 129.911 355.245 128.251C355.245 126.591 354.107 125.323 352.388 125.323C350.681 125.323 349.543 126.591 349.543 128.251C349.543 129.911 350.681 131.179 352.388 131.179ZM352.388 130.254C351.345 130.254 350.586 129.436 350.586 128.251C350.586 127.077 351.345 126.248 352.388 126.248C353.443 126.248 354.19 127.077 354.19 128.251C354.19 129.436 353.443 130.254 352.388 130.254Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M358.858 131.179C359.818 131.179 360.446 130.622 360.612 129.614L359.664 129.401C359.569 130.017 359.296 130.278 358.822 130.278C358.395 130.278 358.051 130.005 358.051 129.436V126.307H360.067V125.442H358.051V123.699H357.02V125.442H355.906V126.307H357.02V129.389C357.02 130.503 357.66 131.179 358.858 131.179Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M363.341 131.179C364.266 131.179 364.989 130.764 365.274 130.171V131.061H366.258V127.54C366.258 126.165 365.404 125.323 363.863 125.323C362.512 125.323 361.658 126.046 361.445 127.089L362.369 127.35C362.512 126.627 363.057 126.188 363.863 126.188C364.669 126.188 365.274 126.615 365.274 127.457V128.038L364.764 127.895C364.385 127.777 363.958 127.718 363.567 127.718C362.44 127.718 361.48 128.239 361.48 129.46C361.48 130.539 362.334 131.179 363.341 131.179ZM363.685 130.278C362.927 130.278 362.535 129.911 362.535 129.401C362.535 128.796 362.998 128.512 363.709 128.512C364.017 128.512 364.361 128.571 364.752 128.69L365.274 128.844V128.962C365.274 129.804 364.598 130.278 363.685 130.278Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M367.842 131.061H368.861V122.762H367.842V131.061Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M219.335 125.252L220.354 124.671C219.904 123.391 218.742 122.703 217.402 122.703C215.695 122.703 214.605 123.711 214.605 124.92C214.605 126.366 215.778 127.101 217.485 127.398C219.097 127.658 219.572 128.121 219.572 128.82C219.572 129.65 218.789 130.207 217.58 130.207C216.217 130.207 215.34 129.413 215.008 128.073L214 128.702C214.616 130.658 216.217 131.238 217.568 131.238C219.406 131.238 220.698 130.207 220.698 128.784C220.698 127.48 219.797 126.781 217.865 126.414C216.632 126.176 215.695 125.785 215.695 124.896C215.695 124.161 216.395 123.734 217.307 123.734C218.374 123.734 219.062 124.268 219.335 125.252Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M223.506 131.238C224.431 131.238 225.154 130.823 225.438 130.231V131.12H226.422V127.599C226.422 126.224 225.569 125.382 224.028 125.382C222.676 125.382 221.823 126.105 221.609 127.149L222.534 127.409C222.676 126.686 223.222 126.248 224.028 126.248C224.834 126.248 225.438 126.674 225.438 127.516V128.097L224.929 127.955C224.549 127.836 224.123 127.777 223.731 127.777C222.605 127.777 221.645 128.298 221.645 129.519C221.645 130.598 222.499 131.238 223.506 131.238ZM223.85 130.337C223.091 130.337 222.7 129.97 222.7 129.46C222.7 128.856 223.162 128.571 223.874 128.571C224.182 128.571 224.526 128.63 224.917 128.749L225.438 128.903V129.022C225.438 129.863 224.763 130.337 223.85 130.337Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M228.007 131.12H229.026V122.822H228.007V131.12Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M233.101 130.337C232.176 130.337 231.323 129.745 231.311 128.464H235.377C235.424 128.251 235.448 128.026 235.448 127.777C235.448 126.283 234.429 125.382 232.947 125.382C231.323 125.382 230.268 126.674 230.268 128.275C230.268 130.112 231.453 131.238 233.101 131.238C234.452 131.238 235.247 130.515 235.614 129.425L234.725 129.081C234.512 129.863 233.99 130.337 233.101 130.337ZM232.935 126.283C233.729 126.283 234.441 126.71 234.441 127.563C234.441 127.623 234.429 127.67 234.429 127.729H231.311C231.429 126.828 232.081 126.283 232.935 126.283Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M238.868 131.238C240.124 131.238 241.12 130.527 241.12 129.46C241.12 128.559 240.527 127.978 239.152 127.789C238.073 127.635 237.647 127.433 237.647 126.935C237.647 126.485 238.133 126.212 238.737 126.212C239.318 126.212 239.781 126.485 239.97 127.066L240.764 126.627C240.444 125.88 239.852 125.382 238.737 125.382C237.587 125.382 236.71 126.011 236.71 126.923C236.71 127.86 237.421 128.358 238.642 128.536C239.828 128.702 240.124 129.01 240.124 129.519C240.124 130.017 239.65 130.337 238.915 130.337C238.062 130.337 237.564 129.994 237.244 129.211L236.402 129.65C236.722 130.575 237.552 131.238 238.868 131.238Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M65.043 130.219L62.0557 122.762H60.8584L64.2844 131.061H65.8017L69.2277 122.762H68.0422L65.043 130.219Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0876 124.398H71.2256V123.201H70.0876V124.398ZM70.1469 125.441V131.061H71.1664V125.441H70.1469Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2411 130.278C74.3164 130.278 73.4629 129.685 73.451 128.405H77.5171C77.5646 128.192 77.5883 127.966 77.5883 127.718C77.5883 126.224 76.5688 125.323 75.087 125.323C73.4629 125.323 72.4078 126.615 72.4078 128.215C72.4078 130.053 73.5933 131.179 75.2411 131.179C76.5925 131.179 77.3867 130.456 77.7542 129.365L76.8651 129.022C76.6518 129.804 76.1302 130.278 75.2411 130.278ZM75.0751 126.224C75.8694 126.224 76.5806 126.651 76.5806 127.504C76.5806 127.563 76.5688 127.611 76.5688 127.67H73.451C73.5696 126.769 74.2216 126.224 75.0751 126.224Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3369 125.441H78.3293L80.0008 131.061H81.281L82.5258 126.745L83.7705 131.061H85.0389L86.7104 125.441H85.7028L84.3869 130.065L83.1185 125.441H81.9212L80.6528 130.065L79.3369 125.441Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7714 131.179C91.028 131.179 92.0237 130.468 92.0237 129.401C92.0237 128.5 91.431 127.919 90.0559 127.729C88.9771 127.575 88.5504 127.374 88.5504 126.876C88.5504 126.425 89.0364 126.153 89.641 126.153C90.2218 126.153 90.6842 126.425 90.8738 127.006L91.6681 126.568C91.348 125.821 90.7553 125.323 89.641 125.323C88.4911 125.323 87.6139 125.951 87.6139 126.864C87.6139 127.801 88.3251 128.298 89.5461 128.476C90.7316 128.642 91.028 128.95 91.028 129.46C91.028 129.958 90.5538 130.278 89.8188 130.278C88.9653 130.278 88.4674 129.934 88.1473 129.152L87.3056 129.591C87.6257 130.515 88.4555 131.179 89.7714 131.179Z",
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.948,
    cy: 126.043,
    r: 5.56635,
    fill: "#78716C"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.005,
    cy: 126.043,
    r: 5.56635,
    fill: "#FF90E8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.58,
    cy: 126.043,
    r: 5.56635,
    fill: "#D6D3D1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0862 169.799H453.914C455.317 169.799 456.454 170.937 456.454 172.34V376.407C456.454 377.809 455.317 378.947 453.914 378.947H44.0862C42.6833 378.947 41.546 377.809 41.546 376.407V172.34C41.546 170.937 42.6833 169.799 44.0862 169.799Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.6935
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 61.0215,
    y: 273.24,
    width: 16.935,
    height: 85.1028,
    fill: "#E7E5E4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 94.0449,
    y: 246.007,
    width: 16.935,
    height: 112.336,
    fill: "#E7E5E4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 127.068,
    y: 261.325,
    width: 16.935,
    height: 97.0172,
    fill: "#E7E5E4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 160.092,
    y: 303.026,
    width: 16.935,
    height: 55.3168,
    fill: "#E7E5E4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 193.114,
    y: 281.75,
    width: 16.935,
    height: 76.5925,
    fill: "#E7E5E4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 226.138,
    y: 265.58,
    width: 16.935,
    height: 92.762,
    fill: "#E7E5E4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 259.162,
    y: 281.75,
    width: 16.935,
    height: 76.5925,
    fill: "#E7E5E4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 292.185,
    y: 281.75,
    width: 16.935,
    height: 76.5925,
    fill: "#E7E5E4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 325.208,
    y: 291.111,
    width: 16.935,
    height: 67.2312,
    fill: "#E7E5E4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 358.23,
    y: 316.924,
    width: 16.935,
    height: 41.7004,
    fill: "#E7E5E4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 391.255,
    y: 282.032,
    width: 16.935,
    height: 76.5925,
    fill: "#E7E5E4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 424.277,
    y: 290.038,
    width: 16.935,
    height: 68.9332,
    fill: "#E7E5E4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 61.0215,
    y: 346.77,
    width: 16.935,
    height: 11.8545,
    fill: "#78716C"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 94.0449,
    y: 341.69,
    width: 16.935,
    height: 16.935,
    fill: "#78716C"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 127.068,
    y: 340.843,
    width: 16.935,
    height: 17.7818,
    fill: "#78716C"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 160.092,
    y: 346.77,
    width: 16.935,
    height: 11.8545,
    fill: "#78716C"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 193.114,
    y: 340.843,
    width: 16.935,
    height: 17.7818,
    fill: "#78716C"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 292.185,
    y: 346.77,
    width: 16.935,
    height: 11.8545,
    fill: "#78716C"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 424.277,
    y: 344.23,
    width: 16.935,
    height: 14.3948,
    fill: "#78716C"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 391.255,
    y: 346.77,
    width: 16.935,
    height: 11.8545,
    fill: "#78716C"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 358.23,
    y: 352.697,
    width: 16.935,
    height: 5.92726,
    fill: "#78716C"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 325.208,
    y: 351.004,
    width: 16.935,
    height: 7.62076,
    fill: "#78716C"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 226.138,
    y: 344.23,
    width: 16.935,
    height: 14.3948,
    fill: "#78716C"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 260.008,
    y: 352.697,
    width: 15.2415,
    height: 5.92726,
    fill: "#78716C"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.4887,
    cy: 295.965,
    r: 5.08051,
    fill: "#FF90E8"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.513,
    cy: 285.804,
    r: 5.08051,
    fill: "#FF90E8"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.536,
    cy: 278.183,
    r: 5.08051,
    fill: "#FF90E8"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.712,
    cy: 227.378,
    r: 5.08051,
    fill: "#FF90E8"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.736,
    cy: 208.75,
    r: 5.08051,
    fill: "#FF90E8"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.758,
    cy: 208.75,
    r: 5.08051,
    fill: "#FF90E8"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.936,
    cy: 195.202,
    r: 5.08051,
    fill: "#FF90E8"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.958,
    cy: 208.75,
    r: 5.08051,
    fill: "#FF90E8"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.982,
    cy: 232.459,
    r: 5.08051,
    fill: "#FF90E8"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.159,
    cy: 208.75,
    r: 5.08051,
    fill: "#FF90E8"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 397.181,
    cy: 244.313,
    r: 5.08051,
    fill: "#FF90E8"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.206,
    cy: 237.539,
    r: 5.08051,
    fill: "#FF90E8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4893 295.965L102.513 285.804L135.536 278.183L167.712 227.378L200.736 208.75H233.759L265.936 195.202L298.959 208.75L331.982 232.459L364.159 208.75L397.182 244.313L430.205 237.539",
    stroke: "#FF90E8",
    strokeWidth: 2
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 496,
    height: 418.925,
    rx: 20,
    stroke: "black",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowAudience);
export default __webpack_public_path__ + "static/media/growAudience.166774611ac61eb4c15352f6eb5ea1c6.svg";
export { ForwardRef as ReactComponent };